<script>
	import Loader from './../components/Loader.svelte';
    import {onMount} from 'svelte';
    import ApiReportsService from '../services/apiReports.service';
    import OrganizationsService from '../services/organizations.service';
    import Swal from "sweetalert2";

    export let params, errorMessage;
    let loading, canEdit, keysData = [], userKey = {}, organizations = [], selectedOrganization = '',
    loadingAction = false, keyHidden = true;

    let message = {
        show: false,
        type: '',
        text: ''
    }

    const LOADING_HTML = '<div class="loader-wrapper">'+
        '<h1 class="text-center text-primary pt-5">'+
        '<span class="spinning-loader"></span>'+
        '</h1>'+
        '<h3 class="text-center text-muted">Loading...</h3>'+
        '</div>';

    const DAYS_WARNING = 14;

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-right',
        iconColor: 'white',
        customClass: {
            popup: 'colored-toast-success'
        },
        showConfirmButton: false,
        timer: 2500,
    });

    onMount( async () => {
        await verifyPermissions();
        if (canEdit) {
            organizations = await OrganizationsService.list();
            if (organizations.filter(org => org.id === 'revops').length === 0) {
                    organizations.push({
                    id: 'revops',
                    name: 'RevOps'
                });
            }
            if (organizations) selectedOrganization = organizations[0];
            getData();
        } else {
            getUserKey();
        }
    });

    let tab = "codes";

    async function verifyPermissions() {
        loading = true;
        try {
            const response = await ApiReportsService.isAllowed();
            if (response && response.data.ok) canEdit = true;
        } catch (e) {
            errorMessage = e.message;
        } finally {
            loading = false;
        }
    }

    async function getData() {
        errorMessage = null;
        loading = true;
        try {
            const response = await ApiReportsService.getUsers(selectedOrganization.id);
            if (response && response.data) keysData = response.data;
        } catch (e) {
            errorMessage = e.message;
        } finally {
            loading = false;
        }
    }

    async function getKey(keyId, keyIndex) {
        Swal.fire({html: LOADING_HTML, showConfirmButton: false});
        try {
            const response = await ApiReportsService.getKeyData(keyId);

            if (response && response) keysData[keyIndex] = response.data;
        } catch (e) {
            errorMessage = e.message;
        } finally {
            Swal.close();
        }
    }
    
    async function getUserKey() {
        loading = true;
        try {
            const response = await ApiReportsService.getUserKey();
            if (response && response)  userKey = response.data;
        } catch (e) {
            errorMessage = e.message;
        } finally {
            loading = false;
        }
    }

    function hideKey(keyIndex) {
        keysData[keyIndex].key = 'hidden';
    }

    function refreshToken(apiKeyId, keyIndex, name) {
        Swal.fire({
            title: `Generate New Key`,
            icon: 'warning',
            // text: `Do you want to generate a new key for ${name}?`,
            html:`Do you want to generate a new key for <span class='text-primary'>${name}</span>?`,
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            }).then((result) => {
            if (result.isConfirmed) {
                generateKey(apiKeyId, keyIndex);
            }
        })
    }

    async function generateKey(apiKeyId, keyIndex) {
        Swal.fire({html: LOADING_HTML, showConfirmButton: false});
        try {
            const response = await ApiReportsService.generateKey(apiKeyId);
            if (response && response.data) keysData[keyIndex] = response.data;
        } catch (e) {
            errorMessage = e.message;
        } finally {
            Swal.close();
        }
    }

    async function updateKeyStatus(keyData) {
        loading = loadingAction;
        try {
            const response = await ApiReportsService.changeStatus(keyData.apiKeyId, {status: keyData.enabled});
            if (response && response) keyData = response.data
        } catch (e) {
            errorMessage = e.message;
        } finally {
            loadingAction = false;
        }
    }


    let resetMessage = function(){
        message = {
            show: false,
            text: '',
            type: ''
        }
    }

    function changeOrg(organization) {
        selectedOrganization = organization;
        getData();
    }

    function copyKey(key) {
        navigator.clipboard.writeText(key);

        Toast.fire({
            icon: 'success',
            title: 'Key copied'
        })
    }

</script>

<div id="pageDiv">
    <main class="pt-3 container">
        <div class="row">
            <div class="col">
                <h3>API Settings</h3>
                <p>
                    <a class="navbar-brand" href="/dashboard"><small><i class="fa fa-angle-left"></i> Back to the Dashboard</small></a>
                </p>
                {#if loading}
                    <Loader fixed={true}></Loader>
                {:else}
                    
                    {#if message.show}
                        <div class="alert alert-{message.type} mt-3" id="message" role="alert">
                            {message.text}
                            <span class="float-right pointer" on:click={ resetMessage }>x</span>
                        </div>
                    {/if}                   
                    <hr>
                    {#if canEdit}
                        <div class="row">
                            <div class="col-3 mb-2">
                                {#if organizations.length > 0}
                                    <div class="dropdown mb-2 btn-block">
                                        <button class="btn btn-primary btn-block dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {selectedOrganization.name}
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" id="api-reports-org-list">
                                            {#each organizations as organization}
                                                <label class="dropdown-item" on:click={ () => changeOrg(organization) }>
                                                    {organization.name}
                                                </label>
                                            {/each}
                                        </div>
                                    </div>
                                {/if}
                            </div>
                            <div class="col-md-9 text-right">
                                <a href="https://s3.us-west-2.amazonaws.com/new-riverside-kpis.seagage.com/RRAS+KPIs+API+Documentation.pdf" target="_blank" class="btn btn-download">
                                    <i class="fa fa-book mr-1"></i>
                                    Read API Documentation
                                </a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                {#if keysData.length > 0}
                                    <table class="table">
                                        <thead>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>API Key</th>
                                            <th>Days To Expiration</th>
                                            <th>Allow</th>
                                        </thead>
                                        <tbody>
                                            {#each keysData as keyData, keyIndex}
                                                <tr>
                                                    <td>{keyData.name}</td>
                                                    <td>{keyData.email}</td>
                                                    <td>
                                                        {#if keyData.key === 'hidden'}
                                                            <i disabled={loadingAction} class="fa fa-eye text-primary mr-2 pointer"
                                                                on:click={() => getKey(keyData.apiKeyId, keyIndex)}
                                                            >
                                                            </i>
                                                            <i disabled={loadingAction} class="fa fa-refresh text-danger mr-2 pointer" 
                                                                on:click={() => refreshToken(keyData.apiKeyId, keyIndex, keyData.name)}>
                                                            </i>
                                                            XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
                                                        {:else if keyData.key && keyData.key.length > 0}
                                                            <i disabled={loadingAction} class="fa fa-eye-slash text-primary mr-2 pointer"
                                                                on:click={() => hideKey(keyIndex)}
                                                            >
                                                            </i>
                                                            <i disabled={loadingAction} class="fa fa-refresh text-danger mr-2 pointer" 
                                                                on:click={() => refreshToken(keyData.apiKeyId, keyIndex, keyData.name)}>
                                                            </i>
                                                            {keyData.key}
                                                            <i class="fa fa-clipboard ml-1 pointer text-success" on:click={() => copyKey(keyData.key)}></i>
                                                        {:else}
                                                            <i class="mr-2"></i>
                                                            <i class="mr-2"></i>
                                                            <span class="pointer text-primary" on:click={() => generateKey(keyData.apiKeyId, keyIndex)}>Generate Key</span>
                                                        {/if}
                                                    </td>
                                                    <td class="text-center">
                                                        <span class="{keyData.days <= DAYS_WARNING ? 'text-danger' : ''}">
                                                            {keyData.days <= 0 ? 'Expired' : keyData.days}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <input type="checkbox" 
                                                            bind:checked={keyData.enabled} 
                                                            on:change={(e) => updateKeyStatus(keyData)}>
                                                    </td>
                                                </tr>
                                            {/each}
                                        </tbody>
                                    </table>
                                {:else}
                                    <h3 class="text-center text-primary uppercase">No users were found</h3>
                                {/if}
                            </div>
                        </div>
                    {:else}
                        {#if userKey && userKey.key}
                            {#if userKey.enabled}
                                <p><b>API Key:</b>
                                    {#if keyHidden}
                                        <i class="fa fa-eye text-primary mr-2 pointer"  on:click={() => keyHidden = false}>
                                        </i>
                                    XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
                                    {:else}
                                    <i class="fa fa-eye-slash text-primary mr-2 pointer"  on:click={() => keyHidden = true}>
                                    </i>
                                        {userKey.key}
                                        <i class="fa fa-clipboard ml-1 pointer text-success" on:click={() => copyKey(userKey.key)}></i>
                                    {/if}
                                </p>
                                <p>
                                    <b>Days To Expiration:</b> 
                                    <span class="{userKey.days <= DAYS_WARNING ? 'text-danger' : ''}">
                                        {userKey.days <= 0 ? 'Expired' : userKey.days}
                                    </span>
                                </p>
                            {:else}
                                Your key has been disabled. Please contact the Riverside Revenue Operations team.
                            {/if}
                        {:else}
                            You don't have an api key assigned. Please contact the Riverside Revenue Operations team.
                        {/if}
                    {/if}
                        
                {/if}
            </div>
        </div>
    </main>
</div>

<style>
    #api-reports-org-list {
        position: absolute !important;
        transform: translate3d(0px, 36px, 0px) !important;
        top: 0px !important;
        left: 0px !important;
        width: 100% !important;
        will-change: transform !important;
        overflow-y: scroll !important;
        height: 300px !important;
    }
</style>